/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthedRouteRouteImport } from './routes/_authed/route'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as InvitationsTokenRouteImport } from './routes/invitations/$token'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthedVoicemailsRouteImport } from './routes/_authed/voicemails'
import { Route as AuthedUserRouteImport } from './routes/_authed/user'
import { Route as AuthedPhoneNumbersRouteImport } from './routes/_authed/phone-numbers'
import { Route as AuthedCallsRouteImport } from './routes/_authed/calls'
import { Route as AuthedBillingRouteImport } from './routes/_authed/billing'
import { Route as AuthedAnalyticsRouteImport } from './routes/_authed/analytics'
import { Route as AuthedAgentRouteImport } from './routes/_authed/agent'
import { Route as AuthedActiveDashboardRouteImport } from './routes/_authed/active-dashboard'
import { Route as AuthedSystemRouteRouteImport } from './routes/_authed/system/route'
import { Route as AuthedSettingsRouteRouteImport } from './routes/_authed/settings/route'
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed/settings/index'
import { Route as AuthedQueueDashboardIndexRouteImport } from './routes/_authed/queue-dashboard/index'
import { Route as AuthedPersonasIndexRouteImport } from './routes/_authed/personas/index'
import { Route as AuthedFlowsIndexRouteImport } from './routes/_authed/flows/index'
import { Route as AuthedSystemSuperUsersRouteImport } from './routes/_authed/system/super-users'
import { Route as AuthedSystemAiModelsRouteImport } from './routes/_authed/system/ai-models'
import { Route as AuthedSettingsRecordingsRouteImport } from './routes/_authed/settings/recordings'
import { Route as AuthedSettingsQueuesRouteImport } from './routes/_authed/settings/queues'
import { Route as AuthedSettingsMembersRouteImport } from './routes/_authed/settings/members'
import { Route as AuthedSettingsMediaRouteImport } from './routes/_authed/settings/media'
import { Route as AuthedSettingsGeneralRouteImport } from './routes/_authed/settings/general'
import { Route as AuthedSettingsContactCenterRouteImport } from './routes/_authed/settings/contact-center'
import { Route as AuthedSettingsBusinessHoursRouteImport } from './routes/_authed/settings/business-hours'
import { Route as AuthedSettingsBillingRouteImport } from './routes/_authed/settings/billing'
import { Route as AuthedQueueDashboardQueueIdRouteImport } from './routes/_authed/queue-dashboard/$queueId'
import { Route as AuthedPersonasPersonaIdRouteImport } from './routes/_authed/personas/$personaId'
import { Route as AuthedFlowsFlowIdRouteImport } from './routes/_authed/flows/$flowId'
import { Route as AuthedSystemPersonaTemplatesIndexRouteImport } from './routes/_authed/system/persona-templates/index'
import { Route as AuthedSystemOrganizationsIndexRouteImport } from './routes/_authed/system/organizations/index'
import { Route as AuthedSystemFlowTemplatesIndexRouteImport } from './routes/_authed/system/flow-templates/index'
import { Route as AuthedSystemPersonaTemplatesNewRouteImport } from './routes/_authed/system/persona-templates/new'
import { Route as AuthedSystemPersonaTemplatesIdRouteImport } from './routes/_authed/system/persona-templates/$id'
import { Route as AuthedSystemOrganizationsIdRouteImport } from './routes/_authed/system/organizations/$id'
import { Route as AuthedSystemFlowTemplatesNewRouteImport } from './routes/_authed/system/flow-templates/new'
import { Route as AuthedSystemFlowTemplatesIdRouteImport } from './routes/_authed/system/flow-templates/$id'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedVoicemailsRoute = AuthedVoicemailsRouteImport.update({
  id: '/voicemails',
  path: '/voicemails',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedUserRoute = AuthedUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedPhoneNumbersRoute = AuthedPhoneNumbersRouteImport.update({
  id: '/phone-numbers',
  path: '/phone-numbers',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedCallsRoute = AuthedCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedBillingRoute = AuthedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAnalyticsRoute = AuthedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAgentRoute = AuthedAgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedActiveDashboardRoute = AuthedActiveDashboardRouteImport.update({
  id: '/active-dashboard',
  path: '/active-dashboard',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSystemRouteRoute = AuthedSystemRouteRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSettingsRouteRoute = AuthedSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedQueueDashboardIndexRoute =
  AuthedQueueDashboardIndexRouteImport.update({
    id: '/queue-dashboard/',
    path: '/queue-dashboard/',
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedPersonasIndexRoute = AuthedPersonasIndexRouteImport.update({
  id: '/personas/',
  path: '/personas/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedFlowsIndexRoute = AuthedFlowsIndexRouteImport.update({
  id: '/flows/',
  path: '/flows/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSystemSuperUsersRoute = AuthedSystemSuperUsersRouteImport.update({
  id: '/super-users',
  path: '/super-users',
  getParentRoute: () => AuthedSystemRouteRoute,
} as any)
const AuthedSystemAiModelsRoute = AuthedSystemAiModelsRouteImport.update({
  id: '/ai-models',
  path: '/ai-models',
  getParentRoute: () => AuthedSystemRouteRoute,
} as any)
const AuthedSettingsRecordingsRoute =
  AuthedSettingsRecordingsRouteImport.update({
    id: '/recordings',
    path: '/recordings',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsQueuesRoute = AuthedSettingsQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsMembersRoute = AuthedSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsMediaRoute = AuthedSettingsMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsGeneralRoute = AuthedSettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsContactCenterRoute =
  AuthedSettingsContactCenterRouteImport.update({
    id: '/contact-center',
    path: '/contact-center',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsBusinessHoursRoute =
  AuthedSettingsBusinessHoursRouteImport.update({
    id: '/business-hours',
    path: '/business-hours',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsBillingRoute = AuthedSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedQueueDashboardQueueIdRoute =
  AuthedQueueDashboardQueueIdRouteImport.update({
    id: '/queue-dashboard/$queueId',
    path: '/queue-dashboard/$queueId',
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedPersonasPersonaIdRoute = AuthedPersonasPersonaIdRouteImport.update({
  id: '/personas/$personaId',
  path: '/personas/$personaId',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedFlowsFlowIdRoute = AuthedFlowsFlowIdRouteImport.update({
  id: '/flows/$flowId',
  path: '/flows/$flowId',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSystemPersonaTemplatesIndexRoute =
  AuthedSystemPersonaTemplatesIndexRouteImport.update({
    id: '/persona-templates/',
    path: '/persona-templates/',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)
const AuthedSystemOrganizationsIndexRoute =
  AuthedSystemOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)
const AuthedSystemFlowTemplatesIndexRoute =
  AuthedSystemFlowTemplatesIndexRouteImport.update({
    id: '/flow-templates/',
    path: '/flow-templates/',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)
const AuthedSystemPersonaTemplatesNewRoute =
  AuthedSystemPersonaTemplatesNewRouteImport.update({
    id: '/persona-templates/new',
    path: '/persona-templates/new',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)
const AuthedSystemPersonaTemplatesIdRoute =
  AuthedSystemPersonaTemplatesIdRouteImport.update({
    id: '/persona-templates/$id',
    path: '/persona-templates/$id',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)
const AuthedSystemOrganizationsIdRoute =
  AuthedSystemOrganizationsIdRouteImport.update({
    id: '/organizations/$id',
    path: '/organizations/$id',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)
const AuthedSystemFlowTemplatesNewRoute =
  AuthedSystemFlowTemplatesNewRouteImport.update({
    id: '/flow-templates/new',
    path: '/flow-templates/new',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)
const AuthedSystemFlowTemplatesIdRoute =
  AuthedSystemFlowTemplatesIdRouteImport.update({
    id: '/flow-templates/$id',
    path: '/flow-templates/$id',
    getParentRoute: () => AuthedSystemRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/sign-in': typeof SignInRoute
  '/settings': typeof AuthedSettingsRouteRouteWithChildren
  '/system': typeof AuthedSystemRouteRouteWithChildren
  '/active-dashboard': typeof AuthedActiveDashboardRoute
  '/agent': typeof AuthedAgentRoute
  '/analytics': typeof AuthedAnalyticsRoute
  '/billing': typeof AuthedBillingRoute
  '/calls': typeof AuthedCallsRoute
  '/phone-numbers': typeof AuthedPhoneNumbersRoute
  '/user': typeof AuthedUserRoute
  '/voicemails': typeof AuthedVoicemailsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/': typeof AuthedIndexRoute
  '/flows/$flowId': typeof AuthedFlowsFlowIdRoute
  '/personas/$personaId': typeof AuthedPersonasPersonaIdRoute
  '/queue-dashboard/$queueId': typeof AuthedQueueDashboardQueueIdRoute
  '/settings/billing': typeof AuthedSettingsBillingRoute
  '/settings/business-hours': typeof AuthedSettingsBusinessHoursRoute
  '/settings/contact-center': typeof AuthedSettingsContactCenterRoute
  '/settings/general': typeof AuthedSettingsGeneralRoute
  '/settings/media': typeof AuthedSettingsMediaRoute
  '/settings/members': typeof AuthedSettingsMembersRoute
  '/settings/queues': typeof AuthedSettingsQueuesRoute
  '/settings/recordings': typeof AuthedSettingsRecordingsRoute
  '/system/ai-models': typeof AuthedSystemAiModelsRoute
  '/system/super-users': typeof AuthedSystemSuperUsersRoute
  '/flows': typeof AuthedFlowsIndexRoute
  '/personas': typeof AuthedPersonasIndexRoute
  '/queue-dashboard': typeof AuthedQueueDashboardIndexRoute
  '/settings/': typeof AuthedSettingsIndexRoute
  '/system/flow-templates/$id': typeof AuthedSystemFlowTemplatesIdRoute
  '/system/flow-templates/new': typeof AuthedSystemFlowTemplatesNewRoute
  '/system/organizations/$id': typeof AuthedSystemOrganizationsIdRoute
  '/system/persona-templates/$id': typeof AuthedSystemPersonaTemplatesIdRoute
  '/system/persona-templates/new': typeof AuthedSystemPersonaTemplatesNewRoute
  '/system/flow-templates': typeof AuthedSystemFlowTemplatesIndexRoute
  '/system/organizations': typeof AuthedSystemOrganizationsIndexRoute
  '/system/persona-templates': typeof AuthedSystemPersonaTemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/system': typeof AuthedSystemRouteRouteWithChildren
  '/active-dashboard': typeof AuthedActiveDashboardRoute
  '/agent': typeof AuthedAgentRoute
  '/analytics': typeof AuthedAnalyticsRoute
  '/billing': typeof AuthedBillingRoute
  '/calls': typeof AuthedCallsRoute
  '/phone-numbers': typeof AuthedPhoneNumbersRoute
  '/user': typeof AuthedUserRoute
  '/voicemails': typeof AuthedVoicemailsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/': typeof AuthedIndexRoute
  '/flows/$flowId': typeof AuthedFlowsFlowIdRoute
  '/personas/$personaId': typeof AuthedPersonasPersonaIdRoute
  '/queue-dashboard/$queueId': typeof AuthedQueueDashboardQueueIdRoute
  '/settings/billing': typeof AuthedSettingsBillingRoute
  '/settings/business-hours': typeof AuthedSettingsBusinessHoursRoute
  '/settings/contact-center': typeof AuthedSettingsContactCenterRoute
  '/settings/general': typeof AuthedSettingsGeneralRoute
  '/settings/media': typeof AuthedSettingsMediaRoute
  '/settings/members': typeof AuthedSettingsMembersRoute
  '/settings/queues': typeof AuthedSettingsQueuesRoute
  '/settings/recordings': typeof AuthedSettingsRecordingsRoute
  '/system/ai-models': typeof AuthedSystemAiModelsRoute
  '/system/super-users': typeof AuthedSystemSuperUsersRoute
  '/flows': typeof AuthedFlowsIndexRoute
  '/personas': typeof AuthedPersonasIndexRoute
  '/queue-dashboard': typeof AuthedQueueDashboardIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
  '/system/flow-templates/$id': typeof AuthedSystemFlowTemplatesIdRoute
  '/system/flow-templates/new': typeof AuthedSystemFlowTemplatesNewRoute
  '/system/organizations/$id': typeof AuthedSystemOrganizationsIdRoute
  '/system/persona-templates/$id': typeof AuthedSystemPersonaTemplatesIdRoute
  '/system/persona-templates/new': typeof AuthedSystemPersonaTemplatesNewRoute
  '/system/flow-templates': typeof AuthedSystemFlowTemplatesIndexRoute
  '/system/organizations': typeof AuthedSystemOrganizationsIndexRoute
  '/system/persona-templates': typeof AuthedSystemPersonaTemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authed/settings': typeof AuthedSettingsRouteRouteWithChildren
  '/_authed/system': typeof AuthedSystemRouteRouteWithChildren
  '/_authed/active-dashboard': typeof AuthedActiveDashboardRoute
  '/_authed/agent': typeof AuthedAgentRoute
  '/_authed/analytics': typeof AuthedAnalyticsRoute
  '/_authed/billing': typeof AuthedBillingRoute
  '/_authed/calls': typeof AuthedCallsRoute
  '/_authed/phone-numbers': typeof AuthedPhoneNumbersRoute
  '/_authed/user': typeof AuthedUserRoute
  '/_authed/voicemails': typeof AuthedVoicemailsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/flows/$flowId': typeof AuthedFlowsFlowIdRoute
  '/_authed/personas/$personaId': typeof AuthedPersonasPersonaIdRoute
  '/_authed/queue-dashboard/$queueId': typeof AuthedQueueDashboardQueueIdRoute
  '/_authed/settings/billing': typeof AuthedSettingsBillingRoute
  '/_authed/settings/business-hours': typeof AuthedSettingsBusinessHoursRoute
  '/_authed/settings/contact-center': typeof AuthedSettingsContactCenterRoute
  '/_authed/settings/general': typeof AuthedSettingsGeneralRoute
  '/_authed/settings/media': typeof AuthedSettingsMediaRoute
  '/_authed/settings/members': typeof AuthedSettingsMembersRoute
  '/_authed/settings/queues': typeof AuthedSettingsQueuesRoute
  '/_authed/settings/recordings': typeof AuthedSettingsRecordingsRoute
  '/_authed/system/ai-models': typeof AuthedSystemAiModelsRoute
  '/_authed/system/super-users': typeof AuthedSystemSuperUsersRoute
  '/_authed/flows/': typeof AuthedFlowsIndexRoute
  '/_authed/personas/': typeof AuthedPersonasIndexRoute
  '/_authed/queue-dashboard/': typeof AuthedQueueDashboardIndexRoute
  '/_authed/settings/': typeof AuthedSettingsIndexRoute
  '/_authed/system/flow-templates/$id': typeof AuthedSystemFlowTemplatesIdRoute
  '/_authed/system/flow-templates/new': typeof AuthedSystemFlowTemplatesNewRoute
  '/_authed/system/organizations/$id': typeof AuthedSystemOrganizationsIdRoute
  '/_authed/system/persona-templates/$id': typeof AuthedSystemPersonaTemplatesIdRoute
  '/_authed/system/persona-templates/new': typeof AuthedSystemPersonaTemplatesNewRoute
  '/_authed/system/flow-templates/': typeof AuthedSystemFlowTemplatesIndexRoute
  '/_authed/system/organizations/': typeof AuthedSystemOrganizationsIndexRoute
  '/_authed/system/persona-templates/': typeof AuthedSystemPersonaTemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/sign-in'
    | '/settings'
    | '/system'
    | '/active-dashboard'
    | '/agent'
    | '/analytics'
    | '/billing'
    | '/calls'
    | '/phone-numbers'
    | '/user'
    | '/voicemails'
    | '/auth/callback'
    | '/invitations/$token'
    | '/'
    | '/flows/$flowId'
    | '/personas/$personaId'
    | '/queue-dashboard/$queueId'
    | '/settings/billing'
    | '/settings/business-hours'
    | '/settings/contact-center'
    | '/settings/general'
    | '/settings/media'
    | '/settings/members'
    | '/settings/queues'
    | '/settings/recordings'
    | '/system/ai-models'
    | '/system/super-users'
    | '/flows'
    | '/personas'
    | '/queue-dashboard'
    | '/settings/'
    | '/system/flow-templates/$id'
    | '/system/flow-templates/new'
    | '/system/organizations/$id'
    | '/system/persona-templates/$id'
    | '/system/persona-templates/new'
    | '/system/flow-templates'
    | '/system/organizations'
    | '/system/persona-templates'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/system'
    | '/active-dashboard'
    | '/agent'
    | '/analytics'
    | '/billing'
    | '/calls'
    | '/phone-numbers'
    | '/user'
    | '/voicemails'
    | '/auth/callback'
    | '/invitations/$token'
    | '/'
    | '/flows/$flowId'
    | '/personas/$personaId'
    | '/queue-dashboard/$queueId'
    | '/settings/billing'
    | '/settings/business-hours'
    | '/settings/contact-center'
    | '/settings/general'
    | '/settings/media'
    | '/settings/members'
    | '/settings/queues'
    | '/settings/recordings'
    | '/system/ai-models'
    | '/system/super-users'
    | '/flows'
    | '/personas'
    | '/queue-dashboard'
    | '/settings'
    | '/system/flow-templates/$id'
    | '/system/flow-templates/new'
    | '/system/organizations/$id'
    | '/system/persona-templates/$id'
    | '/system/persona-templates/new'
    | '/system/flow-templates'
    | '/system/organizations'
    | '/system/persona-templates'
  id:
    | '__root__'
    | '/_authed'
    | '/sign-in'
    | '/_authed/settings'
    | '/_authed/system'
    | '/_authed/active-dashboard'
    | '/_authed/agent'
    | '/_authed/analytics'
    | '/_authed/billing'
    | '/_authed/calls'
    | '/_authed/phone-numbers'
    | '/_authed/user'
    | '/_authed/voicemails'
    | '/auth/callback'
    | '/invitations/$token'
    | '/_authed/'
    | '/_authed/flows/$flowId'
    | '/_authed/personas/$personaId'
    | '/_authed/queue-dashboard/$queueId'
    | '/_authed/settings/billing'
    | '/_authed/settings/business-hours'
    | '/_authed/settings/contact-center'
    | '/_authed/settings/general'
    | '/_authed/settings/media'
    | '/_authed/settings/members'
    | '/_authed/settings/queues'
    | '/_authed/settings/recordings'
    | '/_authed/system/ai-models'
    | '/_authed/system/super-users'
    | '/_authed/flows/'
    | '/_authed/personas/'
    | '/_authed/queue-dashboard/'
    | '/_authed/settings/'
    | '/_authed/system/flow-templates/$id'
    | '/_authed/system/flow-templates/new'
    | '/_authed/system/organizations/$id'
    | '/_authed/system/persona-templates/$id'
    | '/_authed/system/persona-templates/new'
    | '/_authed/system/flow-templates/'
    | '/_authed/system/organizations/'
    | '/_authed/system/persona-templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  SignInRoute: typeof SignInRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/voicemails': {
      id: '/_authed/voicemails'
      path: '/voicemails'
      fullPath: '/voicemails'
      preLoaderRoute: typeof AuthedVoicemailsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/user': {
      id: '/_authed/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof AuthedUserRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/phone-numbers': {
      id: '/_authed/phone-numbers'
      path: '/phone-numbers'
      fullPath: '/phone-numbers'
      preLoaderRoute: typeof AuthedPhoneNumbersRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/calls': {
      id: '/_authed/calls'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof AuthedCallsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/billing': {
      id: '/_authed/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthedBillingRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/analytics': {
      id: '/_authed/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthedAnalyticsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/agent': {
      id: '/_authed/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AuthedAgentRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/active-dashboard': {
      id: '/_authed/active-dashboard'
      path: '/active-dashboard'
      fullPath: '/active-dashboard'
      preLoaderRoute: typeof AuthedActiveDashboardRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/system': {
      id: '/_authed/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AuthedSystemRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedSettingsIndexRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/queue-dashboard/': {
      id: '/_authed/queue-dashboard/'
      path: '/queue-dashboard'
      fullPath: '/queue-dashboard'
      preLoaderRoute: typeof AuthedQueueDashboardIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/personas/': {
      id: '/_authed/personas/'
      path: '/personas'
      fullPath: '/personas'
      preLoaderRoute: typeof AuthedPersonasIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/flows/': {
      id: '/_authed/flows/'
      path: '/flows'
      fullPath: '/flows'
      preLoaderRoute: typeof AuthedFlowsIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/system/super-users': {
      id: '/_authed/system/super-users'
      path: '/super-users'
      fullPath: '/system/super-users'
      preLoaderRoute: typeof AuthedSystemSuperUsersRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/ai-models': {
      id: '/_authed/system/ai-models'
      path: '/ai-models'
      fullPath: '/system/ai-models'
      preLoaderRoute: typeof AuthedSystemAiModelsRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/settings/recordings': {
      id: '/_authed/settings/recordings'
      path: '/recordings'
      fullPath: '/settings/recordings'
      preLoaderRoute: typeof AuthedSettingsRecordingsRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/queues': {
      id: '/_authed/settings/queues'
      path: '/queues'
      fullPath: '/settings/queues'
      preLoaderRoute: typeof AuthedSettingsQueuesRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/members': {
      id: '/_authed/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthedSettingsMembersRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/media': {
      id: '/_authed/settings/media'
      path: '/media'
      fullPath: '/settings/media'
      preLoaderRoute: typeof AuthedSettingsMediaRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/general': {
      id: '/_authed/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AuthedSettingsGeneralRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/contact-center': {
      id: '/_authed/settings/contact-center'
      path: '/contact-center'
      fullPath: '/settings/contact-center'
      preLoaderRoute: typeof AuthedSettingsContactCenterRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/business-hours': {
      id: '/_authed/settings/business-hours'
      path: '/business-hours'
      fullPath: '/settings/business-hours'
      preLoaderRoute: typeof AuthedSettingsBusinessHoursRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/billing': {
      id: '/_authed/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthedSettingsBillingRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/queue-dashboard/$queueId': {
      id: '/_authed/queue-dashboard/$queueId'
      path: '/queue-dashboard/$queueId'
      fullPath: '/queue-dashboard/$queueId'
      preLoaderRoute: typeof AuthedQueueDashboardQueueIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/personas/$personaId': {
      id: '/_authed/personas/$personaId'
      path: '/personas/$personaId'
      fullPath: '/personas/$personaId'
      preLoaderRoute: typeof AuthedPersonasPersonaIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/flows/$flowId': {
      id: '/_authed/flows/$flowId'
      path: '/flows/$flowId'
      fullPath: '/flows/$flowId'
      preLoaderRoute: typeof AuthedFlowsFlowIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/system/persona-templates/': {
      id: '/_authed/system/persona-templates/'
      path: '/persona-templates'
      fullPath: '/system/persona-templates'
      preLoaderRoute: typeof AuthedSystemPersonaTemplatesIndexRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/organizations/': {
      id: '/_authed/system/organizations/'
      path: '/organizations'
      fullPath: '/system/organizations'
      preLoaderRoute: typeof AuthedSystemOrganizationsIndexRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/flow-templates/': {
      id: '/_authed/system/flow-templates/'
      path: '/flow-templates'
      fullPath: '/system/flow-templates'
      preLoaderRoute: typeof AuthedSystemFlowTemplatesIndexRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/persona-templates/new': {
      id: '/_authed/system/persona-templates/new'
      path: '/persona-templates/new'
      fullPath: '/system/persona-templates/new'
      preLoaderRoute: typeof AuthedSystemPersonaTemplatesNewRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/persona-templates/$id': {
      id: '/_authed/system/persona-templates/$id'
      path: '/persona-templates/$id'
      fullPath: '/system/persona-templates/$id'
      preLoaderRoute: typeof AuthedSystemPersonaTemplatesIdRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/organizations/$id': {
      id: '/_authed/system/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/system/organizations/$id'
      preLoaderRoute: typeof AuthedSystemOrganizationsIdRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/flow-templates/new': {
      id: '/_authed/system/flow-templates/new'
      path: '/flow-templates/new'
      fullPath: '/system/flow-templates/new'
      preLoaderRoute: typeof AuthedSystemFlowTemplatesNewRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
    '/_authed/system/flow-templates/$id': {
      id: '/_authed/system/flow-templates/$id'
      path: '/flow-templates/$id'
      fullPath: '/system/flow-templates/$id'
      preLoaderRoute: typeof AuthedSystemFlowTemplatesIdRouteImport
      parentRoute: typeof AuthedSystemRouteRoute
    }
  }
}

interface AuthedSettingsRouteRouteChildren {
  AuthedSettingsBillingRoute: typeof AuthedSettingsBillingRoute
  AuthedSettingsBusinessHoursRoute: typeof AuthedSettingsBusinessHoursRoute
  AuthedSettingsContactCenterRoute: typeof AuthedSettingsContactCenterRoute
  AuthedSettingsGeneralRoute: typeof AuthedSettingsGeneralRoute
  AuthedSettingsMediaRoute: typeof AuthedSettingsMediaRoute
  AuthedSettingsMembersRoute: typeof AuthedSettingsMembersRoute
  AuthedSettingsQueuesRoute: typeof AuthedSettingsQueuesRoute
  AuthedSettingsRecordingsRoute: typeof AuthedSettingsRecordingsRoute
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute
}

const AuthedSettingsRouteRouteChildren: AuthedSettingsRouteRouteChildren = {
  AuthedSettingsBillingRoute: AuthedSettingsBillingRoute,
  AuthedSettingsBusinessHoursRoute: AuthedSettingsBusinessHoursRoute,
  AuthedSettingsContactCenterRoute: AuthedSettingsContactCenterRoute,
  AuthedSettingsGeneralRoute: AuthedSettingsGeneralRoute,
  AuthedSettingsMediaRoute: AuthedSettingsMediaRoute,
  AuthedSettingsMembersRoute: AuthedSettingsMembersRoute,
  AuthedSettingsQueuesRoute: AuthedSettingsQueuesRoute,
  AuthedSettingsRecordingsRoute: AuthedSettingsRecordingsRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
}

const AuthedSettingsRouteRouteWithChildren =
  AuthedSettingsRouteRoute._addFileChildren(AuthedSettingsRouteRouteChildren)

interface AuthedSystemRouteRouteChildren {
  AuthedSystemAiModelsRoute: typeof AuthedSystemAiModelsRoute
  AuthedSystemSuperUsersRoute: typeof AuthedSystemSuperUsersRoute
  AuthedSystemFlowTemplatesIdRoute: typeof AuthedSystemFlowTemplatesIdRoute
  AuthedSystemFlowTemplatesNewRoute: typeof AuthedSystemFlowTemplatesNewRoute
  AuthedSystemOrganizationsIdRoute: typeof AuthedSystemOrganizationsIdRoute
  AuthedSystemPersonaTemplatesIdRoute: typeof AuthedSystemPersonaTemplatesIdRoute
  AuthedSystemPersonaTemplatesNewRoute: typeof AuthedSystemPersonaTemplatesNewRoute
  AuthedSystemFlowTemplatesIndexRoute: typeof AuthedSystemFlowTemplatesIndexRoute
  AuthedSystemOrganizationsIndexRoute: typeof AuthedSystemOrganizationsIndexRoute
  AuthedSystemPersonaTemplatesIndexRoute: typeof AuthedSystemPersonaTemplatesIndexRoute
}

const AuthedSystemRouteRouteChildren: AuthedSystemRouteRouteChildren = {
  AuthedSystemAiModelsRoute: AuthedSystemAiModelsRoute,
  AuthedSystemSuperUsersRoute: AuthedSystemSuperUsersRoute,
  AuthedSystemFlowTemplatesIdRoute: AuthedSystemFlowTemplatesIdRoute,
  AuthedSystemFlowTemplatesNewRoute: AuthedSystemFlowTemplatesNewRoute,
  AuthedSystemOrganizationsIdRoute: AuthedSystemOrganizationsIdRoute,
  AuthedSystemPersonaTemplatesIdRoute: AuthedSystemPersonaTemplatesIdRoute,
  AuthedSystemPersonaTemplatesNewRoute: AuthedSystemPersonaTemplatesNewRoute,
  AuthedSystemFlowTemplatesIndexRoute: AuthedSystemFlowTemplatesIndexRoute,
  AuthedSystemOrganizationsIndexRoute: AuthedSystemOrganizationsIndexRoute,
  AuthedSystemPersonaTemplatesIndexRoute:
    AuthedSystemPersonaTemplatesIndexRoute,
}

const AuthedSystemRouteRouteWithChildren =
  AuthedSystemRouteRoute._addFileChildren(AuthedSystemRouteRouteChildren)

interface AuthedRouteRouteChildren {
  AuthedSettingsRouteRoute: typeof AuthedSettingsRouteRouteWithChildren
  AuthedSystemRouteRoute: typeof AuthedSystemRouteRouteWithChildren
  AuthedActiveDashboardRoute: typeof AuthedActiveDashboardRoute
  AuthedAgentRoute: typeof AuthedAgentRoute
  AuthedAnalyticsRoute: typeof AuthedAnalyticsRoute
  AuthedBillingRoute: typeof AuthedBillingRoute
  AuthedCallsRoute: typeof AuthedCallsRoute
  AuthedPhoneNumbersRoute: typeof AuthedPhoneNumbersRoute
  AuthedUserRoute: typeof AuthedUserRoute
  AuthedVoicemailsRoute: typeof AuthedVoicemailsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedFlowsFlowIdRoute: typeof AuthedFlowsFlowIdRoute
  AuthedPersonasPersonaIdRoute: typeof AuthedPersonasPersonaIdRoute
  AuthedQueueDashboardQueueIdRoute: typeof AuthedQueueDashboardQueueIdRoute
  AuthedFlowsIndexRoute: typeof AuthedFlowsIndexRoute
  AuthedPersonasIndexRoute: typeof AuthedPersonasIndexRoute
  AuthedQueueDashboardIndexRoute: typeof AuthedQueueDashboardIndexRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedSettingsRouteRoute: AuthedSettingsRouteRouteWithChildren,
  AuthedSystemRouteRoute: AuthedSystemRouteRouteWithChildren,
  AuthedActiveDashboardRoute: AuthedActiveDashboardRoute,
  AuthedAgentRoute: AuthedAgentRoute,
  AuthedAnalyticsRoute: AuthedAnalyticsRoute,
  AuthedBillingRoute: AuthedBillingRoute,
  AuthedCallsRoute: AuthedCallsRoute,
  AuthedPhoneNumbersRoute: AuthedPhoneNumbersRoute,
  AuthedUserRoute: AuthedUserRoute,
  AuthedVoicemailsRoute: AuthedVoicemailsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedFlowsFlowIdRoute: AuthedFlowsFlowIdRoute,
  AuthedPersonasPersonaIdRoute: AuthedPersonasPersonaIdRoute,
  AuthedQueueDashboardQueueIdRoute: AuthedQueueDashboardQueueIdRoute,
  AuthedFlowsIndexRoute: AuthedFlowsIndexRoute,
  AuthedPersonasIndexRoute: AuthedPersonasIndexRoute,
  AuthedQueueDashboardIndexRoute: AuthedQueueDashboardIndexRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  SignInRoute: SignInRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
